import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {

  //收货-部长获取本部门今日收包裹与拆包裹数
  receiveAndUnpackNum: (data) => apiAxios('post', baseURL + '/receive.receiveAndUnpackNum', data),
  //收货-扫描签收
  receiveStore: (data) => apiAxios('post', baseURL + '/receive.store', data),
  //收货-详情搜索
  receivePackageInfo: (data) => apiAxios('post', baseURL + '/receive.packageInfo', data),
  //收货-签收列表
  receiveList: (data) => apiAxios('post', baseURL + '/receive.list', data),
  //收货-关联交易号
  receiveRelationPurchaseNo: (data) => apiAxios('post', baseURL + '/receive.relationPurchaseNo', data),
  //收货-修改备注图片
  updateReceiveRemarkImage: (data) => apiAxios('post', baseURL + '/receive.updateReceiveRemarkImage', data),
  //收货-修改备注
  updateReceiveRemark: (data) => apiAxios('post', baseURL + '/receive.updateReceiveRemark', data),
  //收货-打印包裹信息
  expressPackageInfo: (data) => apiAxios('post', baseURL + '/receive.expressPackageInfo', data),
  // 批量填写退货物流号
  batchExpressUpdate: (data) => apiAxios('post', baseURL + '/receive.refund.batchExpressUpdate', data),

  // 国内退件-列表
  receiverefundList: (data) => apiAxios('post', baseURL + '/receive.refundList', data),
  // 国内退件-录入
  receiveRefundStore: (data) => apiAxios('post', baseURL + '/receive.refundStore', data),
  // 国内退件-删除
  receiveRefundDelete: (data) => apiAxios('post', baseURL + '/receive.refundDelete', data),

  // 线下提货-录入
  receiveOfflineStore: (data) => apiAxios('post', baseURL + '/receive.offlineStore', data),
  // 线下提货-删除
  receiveOfflineDelete: (data) => apiAxios('post', baseURL + '/receive.offlineDelete', data),
  // 线下提货-修改
  receiveOfflineUpdate: (data) => apiAxios('post', baseURL + '/receive.offlineUpdate', data),
  // 线下提货-待提货列表
  receiveOfflineListWait: (data) => apiAxios('post', baseURL + '/receive.offlineListWait', data),
  // 线下提货-已提货待确认列表
  receiveOfflineListNoConfirm: (data) => apiAxios('post', baseURL + '/receive.offlineListNoConfirm', data),
  // 线下提货-已提货已确认列表
  receiveOfflineListConfirm: (data) => apiAxios('post', baseURL + '/receive.offlineListConfirm', data),
  // 线下提货-收货
  receiveOfflineReceive: (data) => apiAxios('post', baseURL + '/receive.offlineReceive', data),
  // 线下提货-绑定交易号
  receiveOfflineBindPurchaseNo: (data) => apiAxios('post', baseURL + '/receive.offlineBindPurchaseNo', data),
  // 线下提货-生成系统物流号
  receiveCreateExpressNo: (data) => apiAxios('post', baseURL + '/receive.createExpressNo', data),
  // 线下提货-退回待提货
  receiveBackToWaitReceive: (data) => apiAxios('post', baseURL + '/receive.backToWaitReceive', data),
  // 线下提货-已收货修改
  receiveOfflineReceiveUpdate: (data) => apiAxios('post', baseURL + '/receive.offlineReceiveUpdate', data),

  // 包裹认领-列表
  claimList: (data) => apiAxios('post', baseURL + '/claim.list', data),
  // 包裹认领-新增
  claimStore: (data) => apiAxios('post', baseURL + '/claim.store', data),
  // 包裹认领-修改
  claimUpdate: (data) => apiAxios('post', baseURL + '/claim.update', data),
  // 包裹认领-删除
  claimDelete: (data) => apiAxios('post', baseURL + '/claim.delete', data),
  // 包裹认领-认领
  claimRelationPurchaseNo: (data) => apiAxios('post', baseURL + '/claim.relationPurchaseNo', data),
  // 包裹认领-打印包裹信息
  claimClaimPackageInfo: (data) => apiAxios('post', baseURL + '/claim.claimPackageInfo', data),

  // 紧急件-录入
  urgentStore: (data) => apiAxios('post', baseURL + '/urgent.store', data),
  // 紧急件-删除
  urgentDelete: (data) => apiAxios('post', baseURL + '/urgent.delete', data),
  // 紧急件-列表
  urgentList: (data) => apiAxios('post', baseURL + '/urgent.list', data),

  // 退换货-列表
  refundList: (data) => apiAxios('post', baseURL + '/receive.refund.list', data),
  // 退换货-添加
  refundsStore: (data) => apiAxios('post', baseURL + '/receive.refund.store', data),
  //退换货-修改
  refundUpdate: (data) => apiAxios('post', baseURL + '/receive.refund.update', data),
  // 退换货-已打包
  refundPack: (data) => apiAxios('post', baseURL + '/receive.refund.pack', data),
  // 退换货-批量标记已打包
  batchMarkPacked: (data) => apiAxios('post', baseURL + '/receive.refund.batchMarkPacked', data),
  // 退换货-直接完成
  refundDirectComplete: (data) => apiAxios('post', baseURL + '/receive.refund.directComplete', data),
  // 退换货-删除
  refundDelete: (data) => apiAxios('post', baseURL + '/receive.refund.delete', data),
  // 退换货-退货物流单号录入
  expressUpdate: (data) => apiAxios('post', baseURL + '/receive.refund.expressUpdate', data),
  // 退换货-退回待打印
  refundUnPrint: (data) => apiAxios('post', baseURL + '/receive.refund.unPrint', data),
  // 退换货-设置返件单号
  setReturnExpress: (data) => apiAxios('post', baseURL + '/receive.refund.setReturnExpress', data),
  // 退换货-换货取消
  cancelExchange: (data) => apiAxios('post', baseURL + '/receive.refund.cancelExchange', data),

}
